import React from 'react';
import PropTypes from 'prop-types';

import styles from './AppSpinner.module.css';

function AppSpinner({ size = 'medium', label = 'Loading...', className = '', inline = false }) {
  const spinnerClassName = [
    styles.spinner,
    styles[size],
    inline && styles.inline,
    className
  ].filter(Boolean).join(' ');

  if (inline) {
    return <span className={spinnerClassName} aria-hidden="true" />;
  }

  return (
    <div className={styles.wrapper} role="status" aria-live="polite" aria-label={label}>
      <span className={spinnerClassName} aria-hidden="true" />
      <span className={styles.label}>{label}</span>
    </div>
  );
}

AppSpinner.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  label: PropTypes.string,
  className: PropTypes.string,
  inline: PropTypes.bool,
};

export default AppSpinner;

